export const IS_TMS_DELIVERY = process.env.NEXT_PUBLIC_IS_TMS_ENABLED === 'true'
